import { type PropsWithChildren } from "react";

import { cx } from "../cx";
import { DOM_IDS } from "../defaults";

interface BodyProps extends PropsWithChildren {
  className?: string;
  /** Mirrors `DesktopShell.Sidebar.Body.overflow`: `hidden` lets the content own scrolling. */
  overflow?: "auto" | "hidden";
}

export const Body = ({
  children,
  className,
  overflow = "auto",
}: Readonly<BodyProps>) => (
  <div
    id={DOM_IDS.communityLeftSidebarBody}
    className={cx(
      "min-h-0 flex-1",
      overflow === "hidden" ? "overflow-hidden" : "overflow-auto",
      className,
    )}
    data-testid="circle-ai-shell-left-sidebar-body"
  >
    {children}
  </div>
);

Body.displayName = "CircleAIAppShell.Layout.Sidebar.Body";
